import ConfiguratorPage from "../UI/ConfiguratorPage";
import ProjectsSidebarMenu from "../UI/Sidebar/SidebarComponents/ProjectsSidebarMenu";
import WorkspaceProjects from "../UI/Workspace/WorkspaceProjects";
import LeftLowerBarProjects from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarProjects";
import RightLowerBarNavButtons from "../UI/LowerBar/LowerBarRightSide/RightLowerBarNavButtons";
import PhotoSidebarMenu from "../UI/Sidebar/SidebarComponents/PhotoSidebarMenu";
import WorkspacePhotoTips from "../UI/Workspace/WorkspacePhotoTips";
import RightLowerBarBackOnly from "../UI/LowerBar/LowerBarRightSide/RightLowerBarBackOnly";
import WorkspacePhotoEditor from "../UI/Workspace/WorkspacePhotoEditor";
import LeftLowerBarPhoto from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarPhoto";
import RightLowerBarCropConfirmation from "../UI/LowerBar/LowerBarRightSide/RightLowerBarCropConfirmation";
import ScaleSidebarMenu from "../UI/Sidebar/SidebarComponents/ScaleSidebarMenu";
import WorkspaceFabricSetScale from "../UI/Workspace/WorkspaceFabricSetScale";
import DistanceSidebarMenu from "../UI/Sidebar/SidebarComponents/DistanceSidebarMenu";
import LeftLowerBarPerspective from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarPerspective";
import RightLowerBarScaleConfirmation from "../UI/LowerBar/LowerBarRightSide/RightLowerBarScaleConfirmation";
import PerspectiveActiveInstructionsSidebarMenu
    from "../UI/Sidebar/SidebarComponents/PerspectiveActiveInstructionsSidebarMenu";
import WorkspaceFabricSetPerspective from "../UI/Workspace/WorkspaceFabricSetPerspective";
import RightLowerBarPlaneConfirmation from "../UI/LowerBar/LowerBarRightSide/RightLowerBarPlaneConfirmation";
import PerspectiveInstructionsSidebarMenu from "../UI/Sidebar/SidebarComponents/PerspectiveInstructionsSidebarMenu";
import WorkspaceFabric from "../UI/Workspace/WorkspaceFabric";
import LeftLowerBarChangeScale from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarChangeScale";
import PlanesSidebarMenu from "../UI/Sidebar/SidebarComponents/PlanesSidebarMenu";
// import PlaneActiveSidebarMenu from "../UI/Sidebar/SidebarComponents/PlaneActiveSidebarMenu";
import LeftLowerBarDeletePlane from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarDeletePlane";
import WallsSidebarMenu from "../UI/Sidebar/SidebarComponents/WallsSidebarMenu";
import WorkspaceFabricCreatePlane from "../UI/Workspace/WorkspaceFabricCreatePlane";
import WindowSidebarMenu from "../UI/Sidebar/SidebarComponents/WindowSidebarMenu";
import DoorSidebarMenu from "../UI/Sidebar/SidebarComponents/DoorSidebarMenu";
import DesignListSidebarMenu from "../UI/Sidebar/SidebarComponents/DesignListSidebarMenu";
import LeftLowerBarDeleteDesign from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarDeleteDesign";
import WorkspaceFabricVisualize from "../UI/Workspace/WorkspaceFabricVisualize";
// import DesignGroupsSidebarMenu from "../UI/Sidebar/SidebarComponents/DesignGroupsSidebarMenu";
import DesignMaterialSidebarMenu from "../UI/Sidebar/SidebarComponents/DesignMaterialSidebarMenu";
import RightLowerBarBack from "../UI/LowerBar/LowerBarRightSide/RightLowerBarBack";
import ResultSidebarMenu from "../UI/Sidebar/SidebarComponents/ResultSidebarMenu";
import WorkspaceResultSelectDesign from "../UI/Workspace/WorkspaceResultSelectDesign";
import RightLowerBarOpenResultDesign from "../UI/LowerBar/LowerBarRightSide/RightLowerBarOpenResultDesign";
import WorkspaceResultMaterials from "../UI/Workspace/WorkspaceResultMaterials";
import OverlapSidebarMenu from "../UI/Sidebar/SidebarComponents/OverlapSidebarMenu";
import WorkspaceFabricAdditionalElementsTool from "../UI/Workspace/WorkspaceFabricAdditionalElementsTool";
import AdditionalsSidebarMenu from "../UI/Sidebar/SidebarComponents/AdditionalsSidebarMenu";
import GroupingSidebarMenu from "../UI/Sidebar/SidebarComponents/GroupingSidebarMenu";
import LeftLowerBarGroupOptions from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarGroupOptions";
import EditGroupSidebarMenu from "../UI/Sidebar/SidebarComponents/EditGroupSidebarMenu";
import RightLowerBarEditGroupConfirmation from "../UI/LowerBar/LowerBarRightSide/RightLowerBarEditGroupConfirmation";
import store from "../store";
import LeftLowerBarDeletePoint from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarDeletePoint";
import WorkspaceFabricPlaneGrouping from "../UI/Workspace/WorkspaceFabricPlaneGrouping";
import SelectPlaneSidebarMenu from "../UI/Sidebar/SidebarComponents/SelectPlaneSidebarMenu";
import LeftLowerBarDesignPlaneOptions from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarDesignPlaneOptions";
import AdditionalsAutoSidebarMenu from "../UI/Sidebar/SidebarComponents/AdditionalsAutoSidebarMenu";
import WorkspaceFabricPreAdditionalElementsTool from "../UI/Workspace/WorkspaceFabricPreAdditionalElementsTool";
import LeftLowerBarEditAdditional from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarEditAdditional";
import WorkspaceFabricGroupSelection from "../UI/Workspace/WorkspaceFabricGroupSelection";
import LeftLowerBarPhotoViewer from "../UI/LowerBar/LowerBarLeftSide/LeftLowerBarPhotoViewer";
import RightLowerBarEditPhotoConfirmation from "../UI/LowerBar/LowerBarRightSide/RightLowerBarEditPhotoConfirmation";
import WorkspaceFabricPlatbandTool from "../UI/Workspace/WorkspaceFabricPlatbandTool";
import PlatbandSidebarMenu from "../UI/Sidebar/SidebarComponents/PlatbandSidebarMenu";

export default {
    name: "configurator",
    path: '/configurator',
    component: ConfiguratorPage,
    meta: {requiresAuth: true, applicationVersion: 'pro'},
    children: [
        {
            name: "projects",
            path: 'projects',
            components: {
                sidebar: ProjectsSidebarMenu,
                workspace: WorkspaceProjects,
                lowerBarLeft: null,
                lowerBarRight: null
            },
        },
        {
            name: "selectProject",
            path: 'projects/project=:projectUUID',
            components: {
                sidebar: ProjectsSidebarMenu,
                workspace: WorkspaceProjects,
                lowerBarLeft: LeftLowerBarProjects,
                lowerBarRight: RightLowerBarNavButtons
            },
            meta: {
                checkSaveProjects: true
            }
        },
        {
            name: "loadPhoto",
            path: 'photo/project=:projectUUID',
            components: {
                sidebar: PhotoSidebarMenu,
                workspace: WorkspacePhotoTips,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarBackOnly
            },
        },
        {
            name: "viewPhoto",
            path: 'photo_viewer/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: PhotoSidebarMenu,
                workspace: WorkspacePhotoEditor,
                lowerBarLeft: LeftLowerBarPhotoViewer,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "EditPhoto",
            path: 'photo/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: PhotoSidebarMenu,
                workspace: WorkspacePhotoEditor,
                lowerBarLeft: LeftLowerBarPhoto,
                lowerBarRight: RightLowerBarEditPhotoConfirmation
            },
        },
        {
            name: "CropPhoto",
            path: 'photo/project=:projectUUID/photo=:photoID/crop',
            components: {
                sidebar: PhotoSidebarMenu,
                workspace: WorkspacePhotoEditor,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarCropConfirmation
            },
        },
        {
            name: "SetScale",
            path: 'setScale/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: ScaleSidebarMenu,
                workspace: WorkspaceFabricSetScale,
                // workspace: WorkspaceDefault,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarBackOnly
            },
        },
        {
            name: "SetScaleDistance",
            path: 'setScaleDistance/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: DistanceSidebarMenu,
                workspace: WorkspaceFabricSetScale,
                lowerBarLeft: LeftLowerBarPerspective,
                lowerBarRight: RightLowerBarScaleConfirmation
            },
        },
        {
            name: "SetPerspective",
            path: 'setperspective/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: PerspectiveActiveInstructionsSidebarMenu,
                workspace: WorkspaceFabricSetPerspective,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "planeCategoriesForPerspective",
            path: 'perspectiveZones/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: PerspectiveInstructionsSidebarMenu,
                workspace: WorkspaceFabric,
                lowerBarLeft: LeftLowerBarChangeScale,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "planeCategoriesForPerspectiveActivePlane",
            path: 'perspectiveZonesActive/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: PerspectiveInstructionsSidebarMenu,
                workspace: WorkspaceFabric,
                lowerBarLeft: LeftLowerBarChangeScale,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        // {
        //     name: "SetPerspectiveSecond",
        //     path: 'perspective/project=:projectUUID/photo=:photoID/set_perspective_second',
        //     components: {
        //         sidebar: PerspectiveSecondSidebarMenu,
        //         workspace: WorkspaceFabric,
        //         lowerBarLeft: null,
        //         lowerBarRight: RightLowerBarNavButtons
        //     },
        // },
        {
            name: "planeCategories",
            path: 'zones/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: PlanesSidebarMenu,
                workspace: WorkspaceFabric,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "planeCategoriesActiveSelection",
            path: 'zones/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: PlanesSidebarMenu,
                workspace: WorkspaceFabric,
                lowerBarLeft: LeftLowerBarDeletePlane,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "wall",
            path: 'zones/wall/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: WallsSidebarMenu,
                workspace: WorkspaceFabricCreatePlane,
                lowerBarLeft: LeftLowerBarDeletePoint,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "window",
            path: 'zones/window/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: WindowSidebarMenu,
                workspace: WorkspaceFabricCreatePlane,
                lowerBarLeft: LeftLowerBarDeletePoint,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "door",
            path: 'zones/door/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: DoorSidebarMenu,
                workspace: WorkspaceFabricCreatePlane,
                lowerBarLeft: LeftLowerBarDeletePoint,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "cutout",
            path: 'zones/cutout/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: OverlapSidebarMenu,
                workspace: WorkspaceFabricCreatePlane,
                lowerBarLeft: LeftLowerBarDeletePoint,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "additional",
            path: 'zones/additional/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: AdditionalsAutoSidebarMenu,
                workspace: WorkspaceFabricPreAdditionalElementsTool,
                lowerBarLeft: LeftLowerBarEditAdditional,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "platband",
            path: 'zones/platband/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: PlatbandSidebarMenu,
                workspace: WorkspaceFabricPlatbandTool,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "additionalManual",
            path: 'zones/additionalManual/project=:projectUUID/photo=:photoID/plane=:planeID',
            components: {
                sidebar: AdditionalsSidebarMenu,
                workspace: WorkspaceFabricAdditionalElementsTool,
                lowerBarLeft: LeftLowerBarDeletePoint,
                lowerBarRight: RightLowerBarPlaneConfirmation
            },
        },
        {
            name: "groupingPlanes",
            path: 'grouping/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: GroupingSidebarMenu,
                workspace: WorkspaceFabricGroupSelection,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "groupingPlanesActive",
            path: 'grouping/active/project=:projectUUID/photo=:photoID/group=:groupID',
            components: {
                sidebar: GroupingSidebarMenu,
                workspace: WorkspaceFabricGroupSelection,
                lowerBarLeft: LeftLowerBarGroupOptions,
                lowerBarRight: RightLowerBarNavButtons
            },
        },
        {
            name: "groupingPlanesActiveEditGroup",
            path: 'grouping/active/editGroup/project=:projectUUID/photo=:photoID/group=:groupID',
            components: {
                sidebar: EditGroupSidebarMenu,
                workspace: WorkspaceFabricPlaneGrouping,
                lowerBarLeft: LeftLowerBarGroupOptions,
                lowerBarRight: RightLowerBarEditGroupConfirmation
            },
            beforeEnter: (to, from, next) => {
                const planeGroup = store.getters["active/PLANE_GROUP"];
                if(!planeGroup){
                    next({
                        name: 'groupingPlanes',
                        params: to.params
                    });
                }
                next();
            },
        },
        {
            name: "designList",
            path: 'design/project=:projectUUID/photo=:photoID',
            components: {
                sidebar: DesignListSidebarMenu,
                workspace: WorkspaceFabric,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarBackOnly
            },
            meta: {checkProducts: true, checkScale: true}
        },
        {
            name: "designListSelected",
            path: 'design/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: DesignListSidebarMenu,
                workspace: WorkspaceFabricVisualize,
                lowerBarLeft: LeftLowerBarDeleteDesign,
                lowerBarRight: RightLowerBarNavButtons
            },
            meta: {checkProducts: true, checkScale: true}
        },
        // {
        //     name: "designGroups",
        //     path: 'design/groups/project=:projectUUID/photo=:photoID/design=:designID',
        //     components: {
        //         sidebar: DesignGroupsSidebarMenu,
        //         workspace: WorkspaceFabricVisualize,
        //         lowerBarLeft: null,
        //         lowerBarRight: RightLowerBarBackOnly
        //     },
        //     meta: {checkProducts: true}
        // },
        // {
        //     name: "designGroupsSelected",
        //     path: 'design/groups/project=:projectUUID/photo=:photoID/design=:designID/group=:idDesignGroup/element=:facadeElement',
        //     components: {
        //         sidebar: DesignGroupsSidebarMenu,
        //         workspace: WorkspaceFabricVisualize,
        //         lowerBarLeft: null,
        //         lowerBarRight: RightLowerBarNavButtons
        //     },
        //     meta: {checkProducts: true}
        // },
        {
            name: "designMaterials",
            path: 'design/materials/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: SelectPlaneSidebarMenu,
                workspace: WorkspaceFabricVisualize,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarBack
            },
            meta: {checkProducts: true, checkScale: true}
        },
        {
            name: "designMaterialsSelectedGroup",
            path: 'design/materials/project=:projectUUID/photo=:photoID/design=:designID/group=:groupID/element=:facadeElement',
            components: {
                sidebar: DesignMaterialSidebarMenu,
                workspace: WorkspaceFabricVisualize,
                lowerBarLeft: LeftLowerBarDesignPlaneOptions,
                lowerBarRight: RightLowerBarBack
            },
            meta: {checkProducts: true, checkScale: true}
        },
        // {
        //     name: "designMaterialsSelectedProduct",
        //     path: 'design/materials/project=:projectUUID/photo=:photoID/design=:designID/group=:idDesignGroup/element=:facadeElement/product=:productUUID',
        //     components: {
        //         sidebar: DesignMaterialSidebarMenu,
        //         workspace: WorkspaceFabricVisualize,
        //         lowerBarLeft: null,
        //         lowerBarRight: RightLowerBarBack
        //     },
        //     meta: {checkProducts: true}
        // },
        {
            name: "resultSelectDesign",
            path: 'result/designs/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: ResultSidebarMenu,
                workspace: WorkspaceResultSelectDesign,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarOpenResultDesign
            },
            meta: {checkProducts: true, checkScale: true}
        },
        {
            name: "resultMaterials",
            path: 'result/materials/project=:projectUUID/photo=:photoID/design=:designID',
            components: {
                sidebar: ResultSidebarMenu,
                workspace: WorkspaceResultMaterials,
                lowerBarLeft: null,
                lowerBarRight: RightLowerBarBack
            },
            meta: {checkProducts: true, checkScale: true}
        },
        {path: '*', redirect: {name: 'liteProjects'}},
    ]
};
